<template>
<div style="width:100%;" >
<b-form-group :disabled="disabled" class="mb-0">
  <b-form-tags v-model="selectedStationsNames" no-outer-focus >
    <template v-slot="{ tags, disabled, addTag }">
      <ul v-if="tags.length > 0" class="list-inline d-inline-block">
        <li v-for="tag in tags" :key="tag" class="list-inline-item">
          <b-form-tag
            @remove="onRemoveTag(tag)"
            :title="tag"
            :disabled="disabled"
            variant="info"
          >{{ tag }}</b-form-tag>
        </li>
      </ul>

      <b-dropdown size="sm" variant="outline-secondary" block menu-class="w-100">
        <template v-slot:button-content>
          <b-icon icon="tag-fill"></b-icon>
          {{ findText }}
        </template>
        <b-dropdown-form @submit.stop.prevent="() => {}">
          <b-form-group
            label-for="tag-search-input"
            :label="optionLabel"
            label-cols-md="auto"
            class="mb-4"
            label-size="sm"
            :disabled="disabled"
          >
            <b-form-input
              v-model="search"
              id="tag-search-input"
              type="search"
              size="sm"
              autocomplete="off"
            ></b-form-input>
          </b-form-group>
        </b-dropdown-form>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item-button
          v-for="option in filteredOptions"
          :key="option[optionID]"
          @click="onOptionClick({ option, addTag })"
        >
          {{ option.name }}
        </b-dropdown-item-button>
        <b-dropdown-text v-if="filteredOptions.length === 0">
          Не выбрано ни одной станции
        </b-dropdown-text>
      </b-dropdown>
    </template>
  </b-form-tags>
</b-form-group>
</div>
</template>
<script>
export default {
  name: 'option-picker',
  data () {
    return {
      search: ''
    }
  },
  computed: {
    criteria () {
      return this.search.trim().toLowerCase()
    },
    filteredOptions () {
      const criteria = this.criteria
      const options = this.availableOptions.filter(opt => this.selectedStationsNames.indexOf(opt.name) === -1)
      if (criteria) {
        return options.filter(opt => opt.name.toLowerCase().indexOf(criteria) > -1)
      }
      return this.$_.sortBy(options, 'name')
    }
  },
  props: {
    optionID: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: true
    },
    optionLabel: {
      type: String,
      required: true
    },
    availableOptions: {
      type: Array,
      required: true
    },
    findText: {
      type: String,
      required: true
    },
    onOptionClick: {
      type: Function,
      required: true
    },
    onRemoveTag: {
      type: Function,
      required: true
    },
    selectedStationsNames: {
      type: Array,
      required: true
    }
  }
}
</script>
